// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/settings.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenFile,
  GenMessage,
  GenService,
} from '@bufbuild/protobuf/codegenv2';
import {
  fileDesc,
  messageDesc,
  serviceDesc,
} from '@bufbuild/protobuf/codegenv2';
import type { Timestamp, TimestampJson } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import type { TimeOfDay, TimeOfDayJson } from '../../google/type/timeofday_pb';
import { file_google_type_timeofday } from '../../google/type/timeofday_pb';
import type { AuditUpdater, AuditUpdaterJson } from './type_common_pb';
import { file_proto_v1_type_common } from './type_common_pb';

/**
 * Describes the file proto/v1/settings.proto.
 */
export const file_proto_v1_settings: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_google_protobuf_timestamp,
      file_google_type_timeofday,
      file_proto_v1_type_common,
    ],
  );

/**
 * @generated from message vmspdb.api.proto.v1.TypesenseSettings
 */
export type TypesenseSettings =
  Message<'vmspdb.api.proto.v1.TypesenseSettings'> & {
    /**
     * @generated from field: string browser_api_key = 1;
     */
    browserApiKey: string;

    /**
     * @generated from field: int32 key_id = 2;
     */
    keyId: number;
  };

/**
 * @generated from message vmspdb.api.proto.v1.TypesenseSettings
 */
export type TypesenseSettingsJson = {
  /**
   * @generated from field: string browser_api_key = 1;
   */
  browserApiKey?: string;

  /**
   * @generated from field: int32 key_id = 2;
   */
  keyId?: number;
};

export type TypesenseSettingsValid = TypesenseSettings;

/**
 * Describes the message vmspdb.api.proto.v1.TypesenseSettings.
 * Use `create(TypesenseSettingsSchema)` to create a new message.
 */
export const TypesenseSettingsSchema: GenMessage<
  TypesenseSettings,
  { jsonType: TypesenseSettingsJson; validType: TypesenseSettingsValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 0);

/**
 * @generated from message vmspdb.api.proto.v1.DropboxSettings
 */
export type DropboxSettings = Message<'vmspdb.api.proto.v1.DropboxSettings'> & {
  /**
   * @generated from field: string app_key = 1;
   */
  appKey: string;

  /**
   * @generated from field: string app_secret = 2;
   */
  appSecret: string;

  /**
   * @generated from field: string folder_name = 3;
   */
  folderName: string;

  /**
   * Converted to asterisks when returned on the UI
   *
   * @generated from field: string refresh_token = 4;
   */
  refreshToken: string;

  /**
   * @generated from field: string access_token = 5;
   */
  accessToken: string;

  /**
   * @generated from field: string user_id = 6;
   */
  userId: string;

  /**
   * @generated from field: string account_id = 7;
   */
  accountId: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdater;
};

/**
 * @generated from message vmspdb.api.proto.v1.DropboxSettings
 */
export type DropboxSettingsJson = {
  /**
   * @generated from field: string app_key = 1;
   */
  appKey?: string;

  /**
   * @generated from field: string app_secret = 2;
   */
  appSecret?: string;

  /**
   * @generated from field: string folder_name = 3;
   */
  folderName?: string;

  /**
   * Converted to asterisks when returned on the UI
   *
   * @generated from field: string refresh_token = 4;
   */
  refreshToken?: string;

  /**
   * @generated from field: string access_token = 5;
   */
  accessToken?: string;

  /**
   * @generated from field: string user_id = 6;
   */
  userId?: string;

  /**
   * @generated from field: string account_id = 7;
   */
  accountId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type DropboxSettingsValid = DropboxSettings;

/**
 * Describes the message vmspdb.api.proto.v1.DropboxSettings.
 * Use `create(DropboxSettingsSchema)` to create a new message.
 */
export const DropboxSettingsSchema: GenMessage<
  DropboxSettings,
  { jsonType: DropboxSettingsJson; validType: DropboxSettingsValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 1);

/**
 * @generated from message vmspdb.api.proto.v1.NotificationSettingsTemplate
 */
export type NotificationSettingsTemplate =
  Message<'vmspdb.api.proto.v1.NotificationSettingsTemplate'> & {
    /**
     * All times are in UTC without DST
     *
     * @generated from field: google.type.TimeOfDay time = 1;
     */
    time?: TimeOfDay;

    /**
     * @generated from field: string email_template = 2;
     */
    emailTemplate: string;

    /**
     * @generated from field: string text_template = 3;
     */
    textTemplate: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.NotificationSettingsTemplate
 */
export type NotificationSettingsTemplateJson = {
  /**
   * All times are in UTC without DST
   *
   * @generated from field: google.type.TimeOfDay time = 1;
   */
  time?: TimeOfDayJson;

  /**
   * @generated from field: string email_template = 2;
   */
  emailTemplate?: string;

  /**
   * @generated from field: string text_template = 3;
   */
  textTemplate?: string;
};

export type NotificationSettingsTemplateValid = NotificationSettingsTemplate;

/**
 * Describes the message vmspdb.api.proto.v1.NotificationSettingsTemplate.
 * Use `create(NotificationSettingsTemplateSchema)` to create a new message.
 */
export const NotificationSettingsTemplateSchema: GenMessage<
  NotificationSettingsTemplate,
  {
    jsonType: NotificationSettingsTemplateJson;
    validType: NotificationSettingsTemplateValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 2);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveySettings
 */
export type ProjectSurveySettings =
  Message<'vmspdb.api.proto.v1.ProjectSurveySettings'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.NotificationSettingsTemplate completed_notification = 2;
     */
    completedNotification?: NotificationSettingsTemplate;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveySettings
 */
export type ProjectSurveySettingsJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.NotificationSettingsTemplate completed_notification = 2;
   */
  completedNotification?: NotificationSettingsTemplateJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ProjectSurveySettingsValid = ProjectSurveySettings;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveySettings.
 * Use `create(ProjectSurveySettingsSchema)` to create a new message.
 */
export const ProjectSurveySettingsSchema: GenMessage<
  ProjectSurveySettings,
  { jsonType: ProjectSurveySettingsJson; validType: ProjectSurveySettingsValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 3);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitSettings
 */
export type ProjectPermitSettings =
  Message<'vmspdb.api.proto.v1.ProjectPermitSettings'> & {
    /**
     * Formula used for calculating the permit amount
     *
     * @generated from field: double city_formula = 1;
     */
    cityFormula: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.NotificationSettingsTemplate approved_paid_notification = 2;
     */
    approvedPaidNotification?: NotificationSettingsTemplate;

    /**
     * @generated from field: vmspdb.api.proto.v1.NotificationSettingsTemplate approved_unpaid_notification = 3;
     */
    approvedUnpaidNotification?: NotificationSettingsTemplate;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectPermitSettings
 */
export type ProjectPermitSettingsJson = {
  /**
   * Formula used for calculating the permit amount
   *
   * @generated from field: double city_formula = 1;
   */
  cityFormula?: number | 'NaN' | 'Infinity' | '-Infinity';

  /**
   * @generated from field: vmspdb.api.proto.v1.NotificationSettingsTemplate approved_paid_notification = 2;
   */
  approvedPaidNotification?: NotificationSettingsTemplateJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.NotificationSettingsTemplate approved_unpaid_notification = 3;
   */
  approvedUnpaidNotification?: NotificationSettingsTemplateJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ProjectPermitSettingsValid = ProjectPermitSettings;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectPermitSettings.
 * Use `create(ProjectPermitSettingsSchema)` to create a new message.
 */
export const ProjectPermitSettingsSchema: GenMessage<
  ProjectPermitSettings,
  { jsonType: ProjectPermitSettingsJson; validType: ProjectPermitSettingsValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 4);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSettings
 */
export type ProjectSettings = Message<'vmspdb.api.proto.v1.ProjectSettings'> & {
  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectPermitSettings permit = 1;
   */
  permit?: ProjectPermitSettings;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveySettings survey = 2;
   */
  survey?: ProjectSurveySettings;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSettings
 */
export type ProjectSettingsJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectPermitSettings permit = 1;
   */
  permit?: ProjectPermitSettingsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveySettings survey = 2;
   */
  survey?: ProjectSurveySettingsJson;
};

export type ProjectSettingsValid = ProjectSettings;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSettings.
 * Use `create(ProjectSettingsSchema)` to create a new message.
 */
export const ProjectSettingsSchema: GenMessage<
  ProjectSettings,
  { jsonType: ProjectSettingsJson; validType: ProjectSettingsValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 5);

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServiceLoadRequest
 */
export type SettingsServiceLoadRequest =
  Message<'vmspdb.api.proto.v1.SettingsServiceLoadRequest'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServiceLoadRequest
 */
export type SettingsServiceLoadRequestJson = {};

export type SettingsServiceLoadRequestValid = SettingsServiceLoadRequest;

/**
 * Describes the message vmspdb.api.proto.v1.SettingsServiceLoadRequest.
 * Use `create(SettingsServiceLoadRequestSchema)` to create a new message.
 */
export const SettingsServiceLoadRequestSchema: GenMessage<
  SettingsServiceLoadRequest,
  {
    jsonType: SettingsServiceLoadRequestJson;
    validType: SettingsServiceLoadRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 6);

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServiceLoadResponse
 */
export type SettingsServiceLoadResponse =
  Message<'vmspdb.api.proto.v1.SettingsServiceLoadResponse'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.DropboxSettings dropbox = 1;
     */
    dropbox?: DropboxSettings;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSettings project = 2;
     */
    project?: ProjectSettings;

    /**
     * @generated from field: vmspdb.api.proto.v1.TypesenseSettings typesense = 3;
     */
    typesense?: TypesenseSettings;
  };

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServiceLoadResponse
 */
export type SettingsServiceLoadResponseJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.DropboxSettings dropbox = 1;
   */
  dropbox?: DropboxSettingsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSettings project = 2;
   */
  project?: ProjectSettingsJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.TypesenseSettings typesense = 3;
   */
  typesense?: TypesenseSettingsJson;
};

export type SettingsServiceLoadResponseValid = SettingsServiceLoadResponse;

/**
 * Describes the message vmspdb.api.proto.v1.SettingsServiceLoadResponse.
 * Use `create(SettingsServiceLoadResponseSchema)` to create a new message.
 */
export const SettingsServiceLoadResponseSchema: GenMessage<
  SettingsServiceLoadResponse,
  {
    jsonType: SettingsServiceLoadResponseJson;
    validType: SettingsServiceLoadResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 7);

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistDropboxRequest
 */
export type SettingsServicePersistDropboxRequest =
  Message<'vmspdb.api.proto.v1.SettingsServicePersistDropboxRequest'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.DropboxSettings dropbox = 1;
     */
    dropbox?: DropboxSettings;
  };

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistDropboxRequest
 */
export type SettingsServicePersistDropboxRequestJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.DropboxSettings dropbox = 1;
   */
  dropbox?: DropboxSettingsJson;
};

export type SettingsServicePersistDropboxRequestValid =
  SettingsServicePersistDropboxRequest;

/**
 * Describes the message vmspdb.api.proto.v1.SettingsServicePersistDropboxRequest.
 * Use `create(SettingsServicePersistDropboxRequestSchema)` to create a new message.
 */
export const SettingsServicePersistDropboxRequestSchema: GenMessage<
  SettingsServicePersistDropboxRequest,
  {
    jsonType: SettingsServicePersistDropboxRequestJson;
    validType: SettingsServicePersistDropboxRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 8);

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistDropboxResponse
 */
export type SettingsServicePersistDropboxResponse =
  Message<'vmspdb.api.proto.v1.SettingsServicePersistDropboxResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistDropboxResponse
 */
export type SettingsServicePersistDropboxResponseJson = {};

export type SettingsServicePersistDropboxResponseValid =
  SettingsServicePersistDropboxResponse;

/**
 * Describes the message vmspdb.api.proto.v1.SettingsServicePersistDropboxResponse.
 * Use `create(SettingsServicePersistDropboxResponseSchema)` to create a new message.
 */
export const SettingsServicePersistDropboxResponseSchema: GenMessage<
  SettingsServicePersistDropboxResponse,
  {
    jsonType: SettingsServicePersistDropboxResponseJson;
    validType: SettingsServicePersistDropboxResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 9);

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistProjectPermitRequest
 */
export type SettingsServicePersistProjectPermitRequest =
  Message<'vmspdb.api.proto.v1.SettingsServicePersistProjectPermitRequest'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectPermitSettings permit = 1;
     */
    permit?: ProjectPermitSettings;
  };

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistProjectPermitRequest
 */
export type SettingsServicePersistProjectPermitRequestJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectPermitSettings permit = 1;
   */
  permit?: ProjectPermitSettingsJson;
};

export type SettingsServicePersistProjectPermitRequestValid =
  SettingsServicePersistProjectPermitRequest;

/**
 * Describes the message vmspdb.api.proto.v1.SettingsServicePersistProjectPermitRequest.
 * Use `create(SettingsServicePersistProjectPermitRequestSchema)` to create a new message.
 */
export const SettingsServicePersistProjectPermitRequestSchema: GenMessage<
  SettingsServicePersistProjectPermitRequest,
  {
    jsonType: SettingsServicePersistProjectPermitRequestJson;
    validType: SettingsServicePersistProjectPermitRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 10);

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistProjectPermitResponse
 */
export type SettingsServicePersistProjectPermitResponse =
  Message<'vmspdb.api.proto.v1.SettingsServicePersistProjectPermitResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistProjectPermitResponse
 */
export type SettingsServicePersistProjectPermitResponseJson = {};

export type SettingsServicePersistProjectPermitResponseValid =
  SettingsServicePersistProjectPermitResponse;

/**
 * Describes the message vmspdb.api.proto.v1.SettingsServicePersistProjectPermitResponse.
 * Use `create(SettingsServicePersistProjectPermitResponseSchema)` to create a new message.
 */
export const SettingsServicePersistProjectPermitResponseSchema: GenMessage<
  SettingsServicePersistProjectPermitResponse,
  {
    jsonType: SettingsServicePersistProjectPermitResponseJson;
    validType: SettingsServicePersistProjectPermitResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 11);

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistProjectSurveyRequest
 */
export type SettingsServicePersistProjectSurveyRequest =
  Message<'vmspdb.api.proto.v1.SettingsServicePersistProjectSurveyRequest'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSurveySettings survey = 1;
     */
    survey?: ProjectSurveySettings;
  };

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistProjectSurveyRequest
 */
export type SettingsServicePersistProjectSurveyRequestJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveySettings survey = 1;
   */
  survey?: ProjectSurveySettingsJson;
};

export type SettingsServicePersistProjectSurveyRequestValid =
  SettingsServicePersistProjectSurveyRequest;

/**
 * Describes the message vmspdb.api.proto.v1.SettingsServicePersistProjectSurveyRequest.
 * Use `create(SettingsServicePersistProjectSurveyRequestSchema)` to create a new message.
 */
export const SettingsServicePersistProjectSurveyRequestSchema: GenMessage<
  SettingsServicePersistProjectSurveyRequest,
  {
    jsonType: SettingsServicePersistProjectSurveyRequestJson;
    validType: SettingsServicePersistProjectSurveyRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 12);

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistProjectSurveyResponse
 */
export type SettingsServicePersistProjectSurveyResponse =
  Message<'vmspdb.api.proto.v1.SettingsServicePersistProjectSurveyResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.SettingsServicePersistProjectSurveyResponse
 */
export type SettingsServicePersistProjectSurveyResponseJson = {};

export type SettingsServicePersistProjectSurveyResponseValid =
  SettingsServicePersistProjectSurveyResponse;

/**
 * Describes the message vmspdb.api.proto.v1.SettingsServicePersistProjectSurveyResponse.
 * Use `create(SettingsServicePersistProjectSurveyResponseSchema)` to create a new message.
 */
export const SettingsServicePersistProjectSurveyResponseSchema: GenMessage<
  SettingsServicePersistProjectSurveyResponse,
  {
    jsonType: SettingsServicePersistProjectSurveyResponseJson;
    validType: SettingsServicePersistProjectSurveyResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_settings, 13);

/**
 * @generated from service vmspdb.api.proto.v1.SettingsService
 */
export const SettingsService: GenService<{
  /**
   * @generated from rpc vmspdb.api.proto.v1.SettingsService.Load
   */
  load: {
    methodKind: 'unary';
    input: typeof SettingsServiceLoadRequestSchema;
    output: typeof SettingsServiceLoadResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.SettingsService.PersistDropbox
   */
  persistDropbox: {
    methodKind: 'unary';
    input: typeof SettingsServicePersistDropboxRequestSchema;
    output: typeof SettingsServicePersistDropboxResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.SettingsService.PersistProjectPermit
   */
  persistProjectPermit: {
    methodKind: 'unary';
    input: typeof SettingsServicePersistProjectPermitRequestSchema;
    output: typeof SettingsServicePersistProjectPermitResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.SettingsService.PersistProjectSurvey
   */
  persistProjectSurvey: {
    methodKind: 'unary';
    input: typeof SettingsServicePersistProjectSurveyRequestSchema;
    output: typeof SettingsServicePersistProjectSurveyResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_proto_v1_settings, 0);
